import { useLocation } from 'react-router-dom';
// @mui
import { Container } from '@mui/material';
// routes
import { PATH_DASHBOARD } from '../../../../routes/paths';
// hooks
import useSettings from '../../../../hooks/useSettings';
// components
import Page from '../../../../components/Page';
import HeaderBreadcrumbs from '../../../../components/HeaderBreadcrumbs';
// sections
import useLocales from 'src/hooks/useLocales';
import ProvinceNewEditForm from './ProvinceNewEditForm';
// ----------------------------------------------------------------------

export default function ProvinceCreate() {
  const { themeStretch } = useSettings();
  const { translate } = useLocales();
  const { pathname } = useLocation();
  const isEdit = pathname.includes('edit');

  return (
    <Page title={translate('Province.AddTitle')}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={
            !isEdit
              ? `${translate('Province.CreateNewProvince')}`
              : `${translate('Province.UpdateProvince')}`
          }
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            { name: `${translate('Province.Province')}`, href: PATH_DASHBOARD.Province.list },
            {
              name: !isEdit
                ? `${translate('Province.CreateNewProvince')}`
                : `${translate('Province.UpdateProvince')}`,
            },
          ]}
        />
        <ProvinceNewEditForm />
      </Container>
    </Page>
  );
}
